import { RvqPreferenceType } from "../Constants/RvqPreferenceType";
import { BaseRvqPreference } from "./BaseRvqPreference";
import { RvqLocationPreference } from "./RvqLocationPreference";
import { RvqMedicationPreference } from "./RvqMedicationPreference";
import { RvqPractitionerPreference } from "./RvqPractitionerPreference";

class RvqPreferenceHelper {
    /**
     * Construct a preference instance for the given type.
     * @param init The values from which to initialize the instance.
     * @param type The preference type to build.
     */
    public static BuildPreference<TPreference extends BaseRvqPreference>(init: Partial<BaseRvqPreference>, type: RvqPreferenceType): TPreference {
        let instance: BaseRvqPreference = null;
        switch (type) {
            case RvqPreferenceType.Location:
                instance = new RvqLocationPreference(init);
                break;

            case RvqPreferenceType.Medication:
                instance = new RvqMedicationPreference(init);
                break;

            case RvqPreferenceType.Practitioner:
                instance = new RvqPractitionerPreference(init);
                break;
        }

        if (!instance) {
            console.error(`Can't build preference for unhandled type '${type}'.`);
            return null;
        }

        return instance as TPreference;
    }
}

export { RvqPreferenceHelper };
